module.exports = __webpack_public_path__ + "img/partners-mobile.6cc0ce13.png";